export default "__VITE_ASSET__YnbLtfVa__"